"use client";

import useSWR from "swr";

interface ListDefinition {
  id: string;
  name: string;
  slug: string;
  [key: string]: unknown;
}

/**
 * SWR key for the list-definitions fetch. Shared with the picker cache
 * warmer in the document detail page — preload() there must use this exact
 * key to hit this hook's cache, so never inline the URL elsewhere.
 */
export const LISTS_DEFINITIONS_KEY = "/api/lists?include_count=false";

export function useListBySlug(slug: string | null) {
  const { data, error, isLoading } = useSWR<{ lists: ListDefinition[] }>(
    slug ? LISTS_DEFINITIONS_KEY : null,
    { revalidateOnFocus: false }
  );

  const list = data?.lists?.find((l) => l.slug === slug) ?? null;

  return {
    list,
    listId: list?.id ?? null,
    isLoading,
    error,
  };
}
